export default __webpack_public_path__ + "static/media/draw-3.5619d904.jpg";